import { render, staticRenderFns } from "./Dialog_CreateSemester.vue?vue&type=template&id=52555b4a&scoped=true&"
import script from "./Dialog_CreateSemester.vue?vue&type=script&lang=js&"
export * from "./Dialog_CreateSemester.vue?vue&type=script&lang=js&"
import style0 from "./Dialog_CreateSemester.vue?vue&type=style&index=0&id=52555b4a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52555b4a",
  null
  
)

export default component.exports